import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'incompatible-scorecard',
  templateUrl: 'incompatible-scorecard.component.html',
  styleUrls: ['incompatible-scorecard.component.scss'],
})
export class IncompatibleScorecardComponent {
  @Input() text: string = 'This segment is not a part of the selected scorecard.';
}
